import { forwardRef, type FormHTMLAttributes } from 'react';
import clsx from 'clsx';

export interface FormProps extends FormHTMLAttributes<HTMLFormElement> {
  gap?: 'sm' | 'md' | 'lg';
}

export const Form = forwardRef<HTMLFormElement, FormProps>(function Form(
  { className, gap = 'md', noValidate = false, ...rest },
  ref,
) {
  return (
    <form
      ref={ref}
      noValidate={noValidate}
      className={clsx(
        'flex flex-col',
        {
          'gap-sm': gap === 'sm',
          'gap-md': gap === 'md',
          'gap-lg': gap === 'lg',
        },
        className,
      )}
      {...rest}
    />
  );
});
